import { VidioHelpers } from 'shared/vidio_helpers';
import AhoyEvent from 'shared/ahoy_event';

export default class LivestreamingPresenceTracker {
  constructor(options) {
    this.$element = $(options.element);
  }

  init() {
    this.sendImpression();
  }

  generateProperties() {
    var properties = {
      livestreaming_id: this.$element.data('id'),
      platform: VidioHelpers.getPlatform(),
      app_name: "vidio",
      stream_type: this.$element.data('stream-type'),
      embed: VidioHelpers.isEmbedVideo(),
      username: $('meta[name="current-username"]').attr('content')
    };

    return properties;
  }

  sendImpression() {
    AhoyEvent.send("LIVESTREAM::PRESENCE", this.generateProperties());
  }
}
